module.exports = __webpack_public_path__ + "static/media/f_id_selfie.c35cdc09.svg";